import * as z from 'zod';

// Types
import { ParagraphZod } from '@/components/atoms/Paragraph/ParagraphType';

const WysiwygZod = z.object({
  __component: z.literal('block.wysiwyg'),
  id: z.number(),
  paragraph: ParagraphZod,
});

export { WysiwygZod };
export type WysiwygType = z.infer<typeof WysiwygZod>;
